"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTEXT_MENU_IGNORE_CLASS = void 0;
const CONTEXT_MENU_IGNORE_CLASS = 'context-menu-ignore';
exports.CONTEXT_MENU_IGNORE_CLASS = CONTEXT_MENU_IGNORE_CLASS;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDT05URVhUX01FTlVfSUdOT1JFX0NMQVNTIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRHJvcGRvd24vQ29udGV4dE1lbnUuY29uc3RzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBDT05URVhUX01FTlVfSUdOT1JFX0NMQVNTID0gJ2NvbnRleHQtbWVudS1pZ25vcmUnXG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFPLE1BQU1BLHlCQUF5QixHQUFHLHFCQUFsQyJ9